export const locale = {
    GENERAL: {
        Navigation: '導航',
        Home: '主頁',
        Home2: '主頁2',
        Standard: '標準',
        Student: '學生',
        Case: '案例',
        EditProfile: '編輯配置',
        Inbox: '收件箱',
        Calendar: '日曆',
        Setting: '設置',
        LogOut: '註銷',
        SearchMenu: '搜索菜單',
        Notifications: '通知',
        NoRecordFound: '找不到記錄',
        SeeAll: '查看全部',
        Login: '登錄',
    },
    HOME: {
        name: '姓名',
        name2: '姓名2',
        gender: '性別',
        center: '中心',
        selectTwo: '第二選擇',
        email: '郵箱',
        birthday: '生日',
        locale: 'zh-tw',
        Male: '男',
        Female: '女',
        Submit: '提交',
        Form: '表單',
    },
    STUDENT: {
        Student: '學生',
        StudentNo: '學生編號',
        LastName: '姓名',
        Gender: '性別',
        CenterName: '中心',
        Phone: '手機號碼',
        Mobile: '電話號碼',
        Center: '中心',
        Telephone: '電話號碼',
        Age: '年齡',
    },
    ASelect: {
        name: '姓名',
        select: '選擇一個項目',
    },

    FullName: '學生姓名',
    Color: '顔色',
    Student: '學生',
    StudentNo: '學生編號',
    LastName: '姓名',
    Gender: '性別',
    CenterName: '中心',
    Phone: '手機號碼',
    Mobile: '電話號碼',
    Center: '中心',
    Telephone: '電話號碼',
    Age: '年齡',
    Name: '姓名',
    Male: '男',
    Female: '女',
    Birthday: '生日',
    Email: '郵箱',

    Save: '保存',
    Search: '搜索',
    Reset: '重置',
    Select: '選擇',
    Add: '添加',
    Remove: '刪除',
    AddStudent: '添加學生',
    Import: '導入',
    Delete: '刪除',
    Cancel: '取消',
    AdvanceSearch: '高級搜索',
    RemoveStudent: '移除學生',
    SelectCurrent: '選擇當前記錄',
    SelectAll: '選擇全部記錄',

    Delete2: '確認要刪除嗎？',
}
